import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-insurance-benefits',
    standalone: true,
    imports: [TranslateModule, CommonModule, SlickCarouselModule],
    templateUrl: './insurance-benefits.component.html',
    styleUrl: './insurance-benefits.component.scss',
})
export class InsuranceBenefitsComponent {
    @Input() isDGPBenifts: boolean = false;
    @Input() isAboutUs: boolean = false;

    slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                    infinite: false,
                },
            },
        ],
    };
}
